function formatCurrency(amount , typeString) {
    const currency = 'RUB';

    const formatter = new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: currency,
    });

    let formattedAmount = formatter.format(amount);

    if (typeString !== "cost" && typeString!=="real" && typeString) {
        formattedAmount = formattedAmount.replace("₽", "B");
    }
    if (typeString === "demo"){


        formattedAmount = formattedAmount.replace("B", "D");

    }
    if (typeString==="roulete"){

        // formattedAmount = formattedAmount.replaceAll(" ","")
        formattedAmount = (formattedAmount.replace("B" , '')).slice(0,-1)


    }
    // //console.log(formattedAmount)

    formattedAmount = formattedAmount.replace(",00", '');
    return formattedAmount;
}
export default formatCurrency;